// src/lib/utils/format/data/hyphenated-words.ts
// AUTO-SPLIT from lib/utils/formatters.ts (A10/A2). New code: import from ~/lib/utils/format.

/**
 * List of properly hyphenated words that should maintain their hyphenation
 * when formatting text. This helps distinguish intentional hyphenation from
 * kebab-case field names that should be converted to title case.
 * 
 * @constant {string[]} DEFAULT_HYPHENATED_WORDS
 */
export const DEFAULT_HYPHENATED_WORDS: string[] = [
  // E-commerce & Digital
  'e-commerce',
  'e-mail',
  
  // Professional Terms
  'co-founder',
  'co-founders',
  'co-owner',
  'co-owners',
  'co-author',
  'co-authors',
  'co-creator',
  'co-worker',
  'self-employed',
  'self-employment',
  'self-service',
  'self-serve',
  'self-directed',
  'self-motivated',
  'self-motivation',
  'self-starter',
  'decision-maker',
  'decision-making',
  'problem-solving',
  
  // User Experience
  'user-friendly',
  'user-generated',
  
  // Business Models
  'business-to-business',
  'business-to-consumer',
  'direct-to-consumer',
  
  // Marketing Funnel
  'top-of-funnel',
  'middle-of-funnel',
  'bottom-of-funnel',
  
  // Business Attributes
  'customer-centric',
  'data-driven',
  'mission-critical',
  'cost-effective',
  'time-consuming',
  
  // Time & Duration
  'long-term',
  'short-term',
  'real-time',
  'full-time',
  'part-time',
  'one-time',
  
  // Quality & Level
  'mid-level',
  'high-end',
  'low-cost',
  'best-in-class',
  'state-of-the-art',
  'up-to-date',
  'first-time',
  
  // Location & Setup
  'in-house',
  'on-site',
  'off-site',
  'on-demand',
  'on-premise',
  'off-premise',
  
  // Interaction Types
  'one-on-one',
  'face-to-face',
  'peer-to-peer',
  'end-to-end',
  
  // Process & Operations
  'day-to-day',
  'word-of-mouth',
  'click-through',
  'follow-up',
  'check-in',
  'opt-in',
  'opt-out',
  'sign-up',
  'log-in',
  'roll-out',
  
  // Business Functions
  'cross-functional',
  'cross-platform',
  'cross-sell',
  'up-sell',
  'pre-sale',
  'post-sale',
  'pre-launch',
  'post-launch',
  'go-to-market',
  'return-on-investment',
  
  // Executive & Leadership
  'c-suite',
  
  // Technology
  'x-ray',
  'wi-fi',
  
  // Business Focus
  'b2b-focused',
  'b2c-oriented',
] as const

/**
 * Default minor words that remain lowercase in title case formatting.
 * 
 * @constant {string[]} DEFAULT_MINOR_WORDS
 */
export const DEFAULT_MINOR_WORDS: string[] = [
  'a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'from', 'by', 'in', 'of'
] as const

/**
 * Default word delimiters used to split text into words.
 * 
 * @constant {string[]} DEFAULT_WORD_DELIMITERS
 */
export const DEFAULT_WORD_DELIMITERS: string[] = [' ', '-', '/'] as const
